import { useDependencies } from '@servicetitan/react-ioc';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { FinancingApi } from '@servicetitan/financing-api-client';
import { useQuery } from '@tanstack/react-query';

export const useProviderPreferences = () => {
    const { setupData } = SetupDataStore.useStore();
    const [apiClient] = useDependencies(FinancingApi);

    const settingsResult = useQuery({
        queryKey: ['tenantsProviderPreferences', setupData?.tenantId],
        queryFn: () => apiClient.tenantsGetAllProviderPreferences(setupData?.tenantId ?? ''),
    });

    const enabledProviders =
        settingsResult.data?.data
            ?.filter(p => p.enabled && p.providerName)
            .sort((a, b) => (a.preferred ? -1 : b.preferred ? 1 : 0))
            .map(p => p.providerName) ?? [];

    const preferredProvider = settingsResult.data?.data?.find(p => p.preferred)?.providerName ?? '';

    return {
        enabledProviders,
        preferredProvider,
    };
};
